//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ContactForm from '@/components/Banners/ContactFields/ContactForm.vue';

export default {
  name: 'HolyWoodBanner',
  props: {
    titleId: {
      type: String,
    }
  },
  components: {
    ContactForm,
  },
  data() {
    return {
      userData: {
        name: '',
        phone: '',
        email: '',
        countryOfResidence: '',
      },
      message: null,
      emailValidated: false,
      WantHolyWoodSmile: null,
      hadCosmeticVeneers: null,
      whatMattersMost: null,
      ableToCome: null,

      options: {
        loop: false,
        lazy: true,

        slidesPerView: 1,
        spaceBetween: 10,
        allowTouchMove: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    };
  },

  computed: {

    swiperOptions() {
      return this.options = {
        ...this.options,
        navigation: {
          nextEl: '.next-holywood-' + this.titleId,
          prevEl: '.prev-holywood-' + this.titleId,
        }
      }
    }
  },

  mounted() {
    const nextButton = document.querySelectorAll('.update-message-' + this.titleId);

    nextButton.forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const value = item.getAttribute('data-value');
        const key = item.getAttribute('data-key');
        this[key] = value;
        console.log(this[key]);
        this.updateMessage(key + ': ' + value);
      });
    });

  },
  methods: {

    updateUserData(data) {
      this.userData = { ...data }
    },

    validatePhoneNumber(phoneNumber) {
      const phoneRegex = /^(\+\d{1,2})?\d{8,}$/;
      console.log(phoneNumber, phoneRegex.test(phoneNumber));
      return this.phoneValidated = phoneRegex.test(phoneNumber);
    },
    updateMessage(value) {

      this.message += value + ` `;
      console.log(this.message);
    },

    async contactFormSend() {

      this.message = 'Want HolyWood Smile?: ' + this.WantHolyWoodSmile + ",  had Cosmetic Veneers?: " + this.hadCosmeticVeneers + ",  what Matters Most?: " + this.whatMattersMost + " " + ", countryOfResidence: " + this.userData.countryOfResidence;

      if (!(this.validatePhoneNumber(this.userData.phone))) {
        this.$toast.error(this.$i18n.t('contactForm.wrongPhoneFormat'))
        return
      }

      //if there is files selected
      try {
        let fd = new FormData();

        fd.append("name", this.userData.name);
        fd.append("phone", this.userData.phone);
        fd.append("email", this.userData.email);
        fd.append("message", this.message);
        fd.append("fullsrc", `https://www.ilajak.com${this.$route.fullPath}`);

        this.$toast.info(this.$t("contactForm.sending"), {
          duration: 1000,
        });

        console.log('tost');
        await this.$api.contactFormSend(fd).then((resp) => {
          console.log(resp, 'asdasdasdasd', 'resp.status', resp.status === 200);

          if (resp.status === 200 || resp.status === 204) {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({ event: "form_submitted" });
            // console.log("we are here " + resp.status)

            document.querySelector(".next-holywood-" + this.titleId).click();
            console.log("we are here " + resp.status);
            this.$toast.success(resp.message);
            this.form.phone = null;
            this.form.message = null;

          }
        });
      } catch (e) {
        // this.$toast.error(e.response.data.message);
      }

      // if no files selected

    }
  },

};
